module.exports = __webpack_public_path__ + "static/media/CenterBatchData.d045c9aa.xlsx";